import { normalizeLocale } from "../i18n/locales.ts";

export function localizedValueCandidates<T>(
    values: Readonly<Record<string, T>>,
    locale: string | null | undefined,
): T[] {
    const normalizedLocale = normalizeLocale(locale);
    const language = normalizedLocale?.split("-", 1)[0];
    const candidateKeys = [normalizedLocale, language, "en"].filter(
        (key): key is string => key !== null && key !== undefined,
    );
    const seenKeys = new Set<string>();

    return candidateKeys.flatMap((key) => {
        if (seenKeys.has(key)) return [];
        seenKeys.add(key);
        const value = values[key];
        return value === undefined ? [] : [value];
    });
}

export function resolveLocalizedValue<T>(
    values: Readonly<Record<string, T>>,
    locale: string | null | undefined,
): T | undefined {
    return (
        localizedValueCandidates(values, locale)[0] ?? Object.values(values)[0]
    );
}

export function resolveLocalizedText(
    translations: Readonly<Record<string, string>>,
    locale: string | null | undefined,
): string {
    return resolveLocalizedValue(translations, locale) ?? "";
}
